module.exports = __webpack_public_path__ + "img/icon_activate_account_at.9c42c196.svg";